import { render } from "./feature-two.vue?vue&type=template&id=53dffe07"
import script from "./feature-two.vue?vue&type=script&lang=js"
export * from "./feature-two.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__